<ng-container *transloco="let t">
  <div class="flex bg-slate-50 px-3.5 py-1.5 text-slate-600">
    <div class="flex flex-[3_1_0%] items-center justify-center gap-2 truncate font-medium text-gray-800">
      {{ t("data-warehouse-principals.google_accounts") }}
    </div>
  </div>
  @for (gcPrincipal of gcPrincipals; track gcPrincipal) {
    <div class="group flex gap-x-4 border-y px-3.5 py-3.5 text-sm tracking-tight transition-colors duration-100">
      <div class="flex flex-[3_1_0%] justify-center gap-2 truncate font-medium text-gray-800">
        {{ gcPrincipal }}
      </div>
    </div>
  }
</ng-container>
